import React from 'react';
import PropTypes from 'prop-types';
import {inject, observer} from 'mobx-react';
import {locationShape, withRouter} from 'react-router';

import CategoryBoxLoading from './CategoryBoxLoading';
import AddressModal from '../../../Components/AddressModal/AddressModal';

const FallbackLoadingScreen = () => (
  <div className="container category-screen">
    <CategoryBoxLoading />
  </div>
);

const AddressValidation = ({
  basketNew,
  basketHasAddress,
  basketSummaryIsLoading,
  children,
  loadingScreen,
  location,
  onUseAddress,
  tracker,
}) => {
  const [waitingForBasketSummary, setWaitingForBasketSummary] = React.useState(true);
  const [showAddressPicker, setShowAddressPicker] = React.useState(false);

  const handleOnUseAddress = () => {
    basketNew.getBasketSummary();
    onUseAddress && onUseAddress();
  };

  React.useEffect(() => {
    const hasActiveAppointment = location && location.query && location.query.appointment_id === 'active';
    setShowAddressPicker(!basketHasAddress || hasActiveAppointment);
  }, [basketHasAddress, location]);

  React.useEffect(() => {
    setWaitingForBasketSummary(basketSummaryIsLoading && !basketHasAddress);
  }, [basketSummaryIsLoading, basketHasAddress]);

  React.useEffect(() => {
    if (showAddressPicker) {
      tracker.track('Shown New Booking Address Flow', {
        category: 'Address flow',
      });
    }
  }, [showAddressPicker]);


  if (waitingForBasketSummary) {
    return (<React.Fragment>{loadingScreen}</React.Fragment>);
  }

  if (showAddressPicker) {
    return (
      <div className="basket-no-address" data-testid="basket-no-address">
        <React.Fragment>{loadingScreen}</React.Fragment>
        <AddressModal onUseAddress={handleOnUseAddress} />
      </div>
    );
  }

  return (<div data-testid="basket-has-address">{children}</div>);
};

AddressValidation.propTypes = {
  basketHasAddress: PropTypes.bool.isRequired,
  basketSummaryIsLoading: PropTypes.bool.isRequired,
  basketNew: PropTypes.shape({
    getBasketSummary: PropTypes.func.isRequired,
  }).isRequired,
  children: PropTypes.node,
  loadingScreen: PropTypes.node,
  location: locationShape.isRequired,
  onUseAddress: PropTypes.func.isRequired,
  tracker: PropTypes.shape({
    track: PropTypes.func.isRequired,
  }).isRequired,
};

AddressValidation.defaultProps = {
  children: null,
  loadingScreen: FallbackLoadingScreen,
};

export default inject(({
  store: {
    basketNew,
    basketNew: {
      basketHasAddress,
      basketSummaryIsLoading,
    },
    tracker,
  },
}) => ({
  basketHasAddress,
  basketSummaryIsLoading,
  basketNew,
  tracker,
}))(observer(withRouter(AddressValidation)));



// WEBPACK FOOTER //
// ./spa/Pages/BookingNext/Components/AddressValidation.jsx